import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import {
  company,
  user,
  contractorGetter,
  plant,
  storage,
  externalUnion,
  loadDropdown,
  section,
  userAuth,
  userRights,
  route,
  vehicleMaster,
  transportCost,
  itemGroup,
  Unit,
  Item,
  labTestingParameter,
  ProductAnalysis,
  DayOpenCloseGetter,
  fgBom,
  sfgBom,
  fgProductionGetter,
  sfgProductionApi,
  storeRequisition,
  ProductMovementGetter,
  ProductSale,
  closingStock,
  milkProcTransaction,
  TankerReceive,
  TankerDispatch,
  TankerDispatchTesting,
  sampleIntimation,
  productTesting,
  labResult,
  TankerReceiveTesting,
  itemMasterGroup,
  dashboard,
  plantLossGainReport,
  sectionLossGainReport,
  fgProductionReport,
  sfgStockReport,
  TankerMovementReport,
  TankerTestingReport,
  UnitPackingReport,
  fgProductionSummaryReport,
  tankerBillingReport,
  RmPmStockReport,
  MilkSaleBillReport,
  sfgStockSummaryReport,
  sfgProductionReport,
  MilkProcReport,
  TankerMovementSummaryReport,
  closingStockReport,
  labAnalysis,
  prodRejection,
  companyRights,
  companySettings
} from "../api-urls/api-url-getters";
const apiUrl = environment.apiUrl;

@Injectable({
  providedIn: "root",
})
export class companyGetter {
  getCompanyGridUrl(): string {
    return apiUrl + company.loadGrid;
  }
  getCompanyByIdUrl(): string {
    return apiUrl + company.getCompanyById;
  }
  getDropdownsUrl(): string {
    return apiUrl + company.loadDropdowns;
  }
  getSaveCompanyUrl(): string {
    return apiUrl + company.saveCompany;
  }
  getUpdateCompanyUrl(): string {
    return apiUrl + company.updateCompany;
  }
}

@Injectable({
  providedIn: "root",
})
export class UserGetter {
  getUserGridUrl(): string {
    return apiUrl + user.loadGrid;
  }
  getUserByIdUrl(): string {
    return apiUrl + user.getUserById;
  }
  getDropdownsUrl(): string {
    return apiUrl + user.loadDropdowns;
  }

  loadUserRefDropdownUrl(): string {
    return apiUrl + user.loadUserLayerRefDropdowns;
  }
  saveUserUrl(): string {
    return apiUrl + user.addUser;
  }
  updateUserUrl(): string {
    return apiUrl + user.updateUser;
  }

  savePasswordUrl(): string {
    return apiUrl + user.savePassword;
  }
  confirmOldPasswordUrl(): string {
    return apiUrl + user.confirmOldPassword;
  }
  confirmOtpUrl(): string {
    return apiUrl + user.confirmOtp;
  }
  getOtpUrl(): string {
    return apiUrl + user.getOtp;
  }
}

@Injectable({
  providedIn: "root",
})
export class contractorSetter {
  loadCompanyDropdownUrl(): string {
    return apiUrl + contractorGetter.loadCompanyDropdown;
  }
  loadExtUnionDropdownUrl(): string {
    return apiUrl + contractorGetter.loadExtUnionDropdown;
  }
  loadFormDropdownsUrl(): string {
    return apiUrl + contractorGetter.loadFormDropdowns;
  }

  loadContractorGridUrl(): string {
    return apiUrl + contractorGetter.loadContractorGrid;
  }

  getContractorByIdUrl(): string {
    return apiUrl + contractorGetter.getContractorById;
  }

  addContractorUrl(): string {
    return apiUrl + contractorGetter.addContractor;
  }

  updateContractorUrl(): string {
    return apiUrl + contractorGetter.updateContractor;
  }
}

@Injectable({
  providedIn: "root",
})
export class storageGetter {
  loadCompanyDropDown(): string {
    return apiUrl + storage.companyDropDown;
  }
  loadStorageGrid(): string {
    return apiUrl + storage.loadStorageGrid;
  }
  loadDropdown(): string {
    return apiUrl + storage.loadDropdown;
  }
  getStorageById(): string {
    return apiUrl + storage.getStorageById;
  }
  addStorage(): string {
    return apiUrl + storage.addStorage;
  }
  updateStorage(): string {
    return apiUrl + storage.updateStorage;
  }
}

@Injectable({
  providedIn: "root",
})
export class PlantGetter {
  loadGridData(): string {
    return apiUrl + plant.loadGridData;
  }
  getPlantByIdUrl(): string {
    return apiUrl + plant.getPlantById;
  }
  loadDropdownUrl(): string {
    return apiUrl + plant.loadDropdown;
  }

  loadExtDropdown(): string {
    return apiUrl + plant.loadExtDropdown;
  }
  addPlantUrl(): string {
    return apiUrl + plant.addPlant;
  }
  updatePlantUrl(): string {
    return apiUrl + plant.updatePlant;
  }
}

@Injectable({
  providedIn: "root",
})
export class dropdownSetter {
  countryDropdown(): string {
    return apiUrl + loadDropdown.countryDropdown;
  }
  stateDropdown(): string {
    return apiUrl + loadDropdown.stateDropdown;
  }
  companyDropdown(): string {
    return apiUrl + loadDropdown.companyDropdown;
  }
  extUnionDropdown(): string {
    return apiUrl + loadDropdown.extUnionDropdown;
  }
}

@Injectable({
  providedIn: "root",
})
export class sectionGetter {
  loadComapnyDropdownsUrl(): string {
    return apiUrl + section.loadComapnyDropdown;
  }
  loadDropDownsUrl(): string {
    return apiUrl + section.loadDropDowns;
  }

  loadSectionGridUrl(): string {
    return apiUrl + section.loadSectionGrid;
  }

  addSectionDataUrl(): string {
    return apiUrl + section.addData;
  }

  updateSectionDataUrl(): string {
    return apiUrl + section.updateData;
  }

  loadSectionGridByIdUrl(): string {
    return apiUrl + section.loadSectionGridById;
  }
}

@Injectable({
  providedIn: "root",
})
export class UserAuthGetter {
  savePasswordUrl(): string {
    return apiUrl + userAuth.savePassword;
  }
  getOtpUrl(): string {
    return apiUrl + userAuth.getOtp;
  }
  confirmOtpUrl(): string {
    return apiUrl + userAuth.confirmOtp;
  }

  authUserUrl(): string {
    return apiUrl + userAuth.authUser;
  }

  checkUserUrl(): string {
    return apiUrl + userAuth.checkUser;
  }
}

@Injectable({
  providedIn: "root",
})
export class UserRightsGetter {
  loadMenuNavigationUrl(): string {
    return apiUrl + userRights.loadMenuNavigation;
  }
  loadRootLevelMenuUrl(): string {
    return apiUrl + userRights.loadRootLevelMenu;
  }
  loadUserRightsUrl(): string {
    return apiUrl + userRights.loadUserRights;
  }
  assignUserRightsUrl(): string {
    return apiUrl + userRights.assignUserRights;
  }
  getUserGridUrl(): string {
    return apiUrl + userRights.loadGrid;
  }
  getDropdownsUrl(): string {
    return apiUrl + userRights.loadDropdowns;
  }
}

@Injectable({
  providedIn: "root",
})
export class routeGetter {
  getRouteGridUrl(): string {
    return apiUrl + route.loadGrid;
  }
  getRouteByIdUrl(): string {
    return apiUrl + route.getRouteById;
  }
  getDropdownsUrl(): string {
    return apiUrl + route.loadDropdowns;
  }
  loadCompanyDropdown(): string {
    return apiUrl + route.loadCompany;
  }
  getSaveRouteUrl(): string {
    return apiUrl + route.saveRoute;
  }
  getUpdateRouteUrl(): string {
    return apiUrl + route.updateRoute;
  }
}

@Injectable({
  providedIn: "root",
})
export class vehicleMasterGetter {
  loadVehicleData(): string {
    return apiUrl + vehicleMaster.loadVehicleData;
  }

  loadContractorDropdown(): string {
    return apiUrl + vehicleMaster.loadContractorDropdown;
  }

  loadDropdown(): string {
    return apiUrl + vehicleMaster.loadDropdown;
  }

  addVehicle(): string {
    return apiUrl + vehicleMaster.addVehicle;
  }

  updateVehicle(): string {
    return apiUrl + vehicleMaster.updateVehicle;
  }
  getVehicleById(): string {
    return apiUrl + vehicleMaster.getVehicleById;
  }
}

@Injectable({
  providedIn: "root",
})
export class transportCostGetter {
  getCompanyDropDownUrl(): string {
    return apiUrl + transportCost.getCompanyDropDown;
  }
  getRouteDropDownUrl(): string {
    return apiUrl + transportCost.loadRouteDropdown;
  }
  loadTransportRateUrl(): string {
    return apiUrl + transportCost.loadTransportRate;
  }
  addTransportRateUrl(): string {
    return apiUrl + transportCost.addTransportRate;
  }
  getTransportRateByIdUrl(): string {
    return apiUrl + transportCost.getTransportRateById;
  }
  updateTransportRateUrl(): string {
    return apiUrl + transportCost.updateTransportRate;
  }
  loadRouteUrl(): string {
    return apiUrl + transportCost.loadRoute;
  }
  addRouteUrl(): string {
    return apiUrl + transportCost.addRoute;
  }
  deleteRouteUrl(): string {
    return apiUrl + transportCost.deleteRoute;
  }
}

@Injectable({
  providedIn: "root",
})
export class DayOpenClose {
  loadDaysUrl(): string {
    return apiUrl + DayOpenCloseGetter.loadDays;
  }

  saveDaysUrl(): string {
    return apiUrl + DayOpenCloseGetter.saveDays;
  }
}

@Injectable({
  providedIn: "root",
})
export class FgBomGetter {
  loadCompanyDropDownUrl(): string {
    return apiUrl + fgBom.loadCompanyDropDown;
  }

  loadDropDownsUrl(): string {
    return apiUrl + fgBom.loadDropDowns;
  }
  loadFgBomGridUrl(): string {
    return apiUrl + fgBom.loadFgBomGrid;
  }
  loadMaterialsListUrl(): string {
    return apiUrl + fgBom.loadMaterialsList;
  }

  loadItemListUrl(): string {
    return apiUrl + fgBom.loadItemList;
  }

  getFgBomByIdUrl(): string {
    return apiUrl + fgBom.getFgBomById;
  }

  saveFgBomUrl(): string {
    return apiUrl + fgBom.saveFgBom;
  }

  updateFgBomUrl(): string {
    return apiUrl + fgBom.updateFgBom;
  }
}

@Injectable({
  providedIn: "root",
})
export class SfgBomGetter {
  loadCompanyDropDownUrl(): string {
    return apiUrl + sfgBom.loadCompanyDropDown;
  }

  loadDropDownsUrl(): string {
    return apiUrl + sfgBom.loadDropDowns;
  }

  calculateKgsUrl(): string {
    return apiUrl + sfgBom.calculateKgs;
  }

  loadSfgBomGridUrl(): string {
    return apiUrl + sfgBom.loadSfgBomGrid;
  }

  loadItemListUrl(): string {
    return apiUrl + sfgBom.loadItemList;
  }

  getSfgBomByIdUrl(): string {
    return apiUrl + sfgBom.getSfgBomById;
  }

  saveSfgBomUrl(): string {
    return apiUrl + sfgBom.saveSfgBom;
  }

  updateSfgBomUrl(): string {
    return apiUrl + sfgBom.updateSfgBom;
  }
}

@Injectable({
  providedIn: "root",
})
export class unionSetter {
  loadDropdown(): string {
    return apiUrl + externalUnion.loadDropdown;
  }
  loadCompanyDropdown(): string {
    return apiUrl + externalUnion.loadCompanyDropdown;
  }
  loadUnion(): string {
    return apiUrl + externalUnion.loadUnion;
  }
  getUnionByid(): string {
    return apiUrl + externalUnion.getUnionByid;
  }
  addUnion(): string {
    return apiUrl + externalUnion.addUnion;
  }
  updateUnion(): string {
    return apiUrl + externalUnion.updateUnion;
  }
}

@Injectable({
  providedIn: "root",
})
export class itemGroupSetter {
  getCompanyDropdownUrl(): string {
    return apiUrl + itemGroup.loadCompanyDropdown;
  }
  getExtUnionDropdownUrl(): string {
    return apiUrl + itemGroup.loadExtUnionDropdown;
  }

  getLoadItemGroupUrl(): string {
    return apiUrl + itemGroup.loadItemGroup;
  }

  getItemGroupByIdUrl(): string {
    return apiUrl + itemGroup.getItemGroupById;
  }

  getAddItemGroupUrl(): string {
    return apiUrl + itemGroup.addItemGroup;
  }

  getUpdateItemGroupUrl(): string {
    return apiUrl + itemGroup.updateItemGroup;
  }
}

@Injectable({
  providedIn: "root",
})
export class unitSetter {
  loadCompanyDropdown(): string {
    return apiUrl + Unit.loadCompanyDropdown;
  }
  loadUnitDropdown(): string {
    return apiUrl + Unit.loadUnitDropdown;
  }
  loadUnit(): string {
    return apiUrl + Unit.loadUnit;
  }
  getUnitById(): string {
    return apiUrl + Unit.getUnitById;
  }
  addUnit(): string {
    return apiUrl + Unit.addUnit;
  }
  updateUnit(): string {
    return apiUrl + Unit.updateUnit;
  }
}

@Injectable({
  providedIn: "root",
})
export class itemSetter {
  getCompanyDropdownUrl(): string {
    return apiUrl + Item.loadCompanyDropdown;
  }
  getGridDropdownUrl(): string {
    return apiUrl + Item.loadGridDropdown;
  }
  oncompanyChangeUrl(): string {
    return apiUrl + Item.onCompanyChangeDropdown;
  }
  loadUnitDropdownForMappingUrl(): string {
    return apiUrl + Item.loadUnitDropdownForMapping;
  }
  loadItem(): string {
    return apiUrl + Item.loadItem;
  }
  getItemById(): string {
    return apiUrl + Item.getItemById;
  }
  addItem(): string {
    return apiUrl + Item.addItemWithStockAndUnit;
  }
  updateItem(): string {
    return apiUrl + Item.updateItemWithStockAndUnit;
  }
}

@Injectable({
  providedIn: "root",
})
export class LabTestingParameterGetter {
  loadDropdownsUrl(): string {
    return apiUrl + labTestingParameter.loadDropdowns;
  }
  loadGridUrl(): string {
    return apiUrl + labTestingParameter.loadGrid;
  }
  getParameterByIdUrl(): string {
    return apiUrl + labTestingParameter.getParameterById;
  }
  addParameterUrl(): string {
    return apiUrl + labTestingParameter.addParameter;
  }
  updateParameterUrl(): string {
    return apiUrl + labTestingParameter.updateParameter;
  }
}

@Injectable({
  providedIn: "root",
})
export class ProductAnalysisGetter {
  loadCompanyDropdownUrl(): string {
    return apiUrl + ProductAnalysis.loadCompanyDropdown;
  }

  loadDropdownsUrl(): string {
    return apiUrl + ProductAnalysis.loadDropdowns;
  }

  loadPrameterValuesUrl(): string {
    return apiUrl + ProductAnalysis.loadPrameterValues;
  }

  loadGridUrl(): string {
    return apiUrl + ProductAnalysis.loadGrid;
  }
  getProductAnalysisByItemIdUrl(): string {
    return apiUrl + ProductAnalysis.getProductAnalysisByItemId;
  }
  assignProductParamMappingsUrl(): string {
    return apiUrl + ProductAnalysis.assignProductParamMappings;
  }
}

@Injectable({
  providedIn: "root",
})
export class fgProductionUrlSetter {
  loadCompanyDropdownUrl(): string {
    return apiUrl + fgProductionGetter.loadCompanyDropdown;
  }
  onCompanyChangeDropdownUrl(): string {
    return apiUrl + fgProductionGetter.onCompanyChangeDropdown;
  }
  loadGridUrl(): string {
    return apiUrl + fgProductionGetter.loadGrid;
  }
  calculateQtyUrl(): string {
    return apiUrl + fgProductionGetter.calculateQty;
  }
  loadMaterialsForNewUrl(): string {
    return apiUrl + fgProductionGetter.loadMaterialsForNew;
  }
  loadProductByIdUrl(): string {
    return apiUrl + fgProductionGetter.loadProductById;
  }
  LoadItemListByTypeUrl(): string {
    return apiUrl + fgProductionGetter.LoadItemListByType;
  }
  findAvailableQtyUrl(): string {
    return apiUrl + fgProductionGetter.findAvailableQty;
  }
  loadFgBomDropdownUrl(): string {
    return apiUrl + fgProductionGetter.loadFgBomDropdown;
  }
  saveFgProdUrl(): string {
    return apiUrl + fgProductionGetter.saveFgProd;
  }
  updateFgProdUrl(): string {
    return apiUrl + fgProductionGetter.updateFgProd;
  }
  deleteFgProdUrl(): string {
    return apiUrl + fgProductionGetter.deleteFgProd;
  }
}
@Injectable({
  providedIn: "root",
})
// Transaction
export class SfgProduction {
  loadCompanyDropDownUrl(): string {
    return apiUrl + sfgProductionApi.loadCompanyDropDown;
  }

  loadDropDownsUrl(): string {
    return apiUrl + sfgProductionApi.loadDropDowns;
  }

  loadSfgBomGridByDateUrl(): string {
    return apiUrl + sfgProductionApi.loadSfgBomGridByDate;
  }

  calculateKgsUrl(): string {
    return apiUrl + sfgProductionApi.calculateKgs;
  }

  loadItemListDDUrl(): string {
    return apiUrl + sfgProductionApi.loadItemListDD;
  }

  LoadItemListByTypeUrl(): string {
    return apiUrl + sfgProductionApi.LoadItemListByType;
  }
  LoadUnitDDUrl(): string {
    return apiUrl + sfgProductionApi.LoadUnitDD;
  }

  loadItemListArrayUrl(): string {
    return apiUrl + sfgProductionApi.loadItemListArray;
  }
  OnProdQtyChangeUrl(): string {
    return apiUrl + sfgProductionApi.OnProdQtyChange;
  }
  FindAvailbleQtyUrl(): string {
    return apiUrl + sfgProductionApi.FindAvailbleQty;
  }

  getSfgBomByIdUrl(): string {
    return apiUrl + sfgProductionApi.getSfgBomById;
  }

  saveSfgBomUrl(): string {
    return apiUrl + sfgProductionApi.saveSfgBom;
  }

  updateSfgBomUrl(): string {
    return apiUrl + sfgProductionApi.updateSfgBom;
  }

  deleteSfgProd(): string {
    return apiUrl + sfgProductionApi.deleteSfgProd;
  }
}

@Injectable({
  providedIn: "root",
})
export class StoreRequisition {
  loadDropDownsUrl(): string {
    return apiUrl + storeRequisition.loadDropDowns;
  }
  loadItemListUrl(): string {
    return apiUrl + storeRequisition.loadItemList;
  }
  loadUnitListUrl(): string {
    return apiUrl + storeRequisition.loadUnitlist;
  }
  loadSRGridByDateRangeUrl(): string {
    return apiUrl + storeRequisition.loadSRGridByDateRange;
  }
  addSRSlipUrl(): string {
    return apiUrl + storeRequisition.addSRSlip;
  }
  GetSRByIdUrl(): string {
    return apiUrl + storeRequisition.GetSRById;
  }
  updateSRSlipUrl(): string {
    return apiUrl + storeRequisition.updateSRSlip;
  }
  DeleteSRUrl(): string {
    return apiUrl + storeRequisition.DeleteSR;
  }
}

@Injectable({
  providedIn: "root",
})
// Transaction
export class ProductMovementSetter {
  loadCompanyDropdownUrl(): string {
    return apiUrl + ProductMovementGetter.loadCompanyDropdown;
  }

  onCompanyChangeDropdownUrl(): string {
    return apiUrl + ProductMovementGetter.onCompanyChangeDropdown;
  }

  allDropdownsOfCompanyUrl(): string {
    return apiUrl + ProductMovementGetter.allDropdownsOfCompany;
  }

  loadGridUrl(): string {
    return apiUrl + ProductMovementGetter.loadGrid;
  }

  getProdMovementByIdUrl(): string {
    return apiUrl + ProductMovementGetter.getProdMovementById;
  }

  loadItemDropdownsUrl(): string {
    return apiUrl + ProductMovementGetter.loadItemDropdowns;
  }

  loadUnitDropdownsUrl(): string {
    return apiUrl + ProductMovementGetter.loadUnitDropdowns;
  }

  addProdMovementUrl(): string {
    return apiUrl + ProductMovementGetter.addProdMovement;
  }
  updateProdMovementUrl(): string {
    return apiUrl + ProductMovementGetter.updateProdMovement;
  }

  deleteProdMovementUrl(): string {
    return apiUrl + ProductMovementGetter.deleteProdMovement;
  }

  calculateKgFatKgSnfUrl(): string {
    return apiUrl + ProductMovementGetter.calculateKgFatKgSnf;
  }
}

@Injectable({
  providedIn: "root",
})
// Transaction
export class ProductSaleSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + ProductSale.loadMasterDropdowns;
  }

  loadItemDropdownUrl(): string {
    return apiUrl + ProductSale.loadItemDropdown;
  }

  loadItemUnitMappingDropdownUrl(): string {
    return apiUrl + ProductSale.loadItemUnitMappingDropdown;
  }

  loadProductSaleGridUrl(): string {
    return apiUrl + ProductSale.loadProductSaleGrid;
  }

  addProductSaleUrl(): string {
    return apiUrl + ProductSale.addProductSale;
  }
  getProductSaleByIdUrl(): string {
    return apiUrl + ProductSale.getProductSaleById;
  }

  deleteProductSaleUrl(): string {
    return apiUrl + ProductSale.deleteProductSale;
  }
  updateProductSaleUrl(): string {
    return apiUrl + ProductSale.updateProductSale;
  }
  validateExcelImportUrl(): string {
    return apiUrl + ProductSale.validateExcelImport;
  }
}
@Injectable({
  providedIn: "root",
})
export class closingStockSetter {
  loadDropDownsUrl(): string {
    return apiUrl + closingStock.loadDropDowns;
  }
  loadItemListUrl(): string {
    return apiUrl + closingStock.loadItemList;
  }
  loadUnitListUrl(): string {
    return apiUrl + closingStock.loadUnitlist;
  }

  loadShiftListUrl(): string {
    return apiUrl + closingStock.loadShiftList;
  }
  loadGridByDateRangeUrl(): string {
    return apiUrl + closingStock.loadGridByDateRange;
  }
  addClosingStockUrl(): string {
    return apiUrl + closingStock.addClosingStock;
  }
  getByIdUrl(): string {
    return apiUrl + closingStock.getById;
  }
  updateClosingStockUrl(): string {
    return apiUrl + closingStock.updateClosingStock;
  }
  deleteClosingStockUrl(): string {
    return apiUrl + closingStock.deleteClosingStock;
  }
}
@Injectable({
  providedIn: "root",
})
export class MilkProcTransaction {
  loadDropDownsUrl(): string {
    return apiUrl + milkProcTransaction.loadDropDowns;
  }
  loadGridByDateRangeUrl(): string {
    return apiUrl + milkProcTransaction.loadGridByDateRange;
  }
  loadShiftListUrl(): string {
    return apiUrl + milkProcTransaction.loadShiftList;
  }
  loadItemIdsUrl(): string {
    return apiUrl + milkProcTransaction.loadItemIds;
  }
  addMilkProcUrl(): string {
    return apiUrl + milkProcTransaction.addMilkProc;
  }
  GetByIdUrl(): string {
    return apiUrl + milkProcTransaction.GetById;
  }
  updateMilkProcUrl(): string {
    return apiUrl + milkProcTransaction.updateMilkProc;
  }
  DeleteMilkProcUrl(): string {
    return apiUrl + milkProcTransaction.DeleteMilkProc;
  }
}

@Injectable({
  providedIn: "root",
})
// Transaction
export class TankerDispatchSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + TankerDispatch.loadMasterDropdowns;
  }

  loadRouteDropdownUrl(): string {
    return apiUrl + TankerDispatch.loadRouteDropdown;
  }

  loadLabsDropdownsUrl(): string {
    return apiUrl + TankerDispatch.loadLabsDropdowns;
  }

  loadItemUnitMappingDropdownUrl(): string {
    return apiUrl + TankerDispatch.loadItemUnitMappingDropdown;
  }

  loadTankerDispatchGridUrl(): string {
    return apiUrl + TankerDispatch.loadTankerDispatchGrid;
  }

  addTankerDispatchUrl(): string {
    return apiUrl + TankerDispatch.addTankerDispatch;
  }

  getTankerDispatchByIdUrl(): string {
    return apiUrl + TankerDispatch.getTankerDispatchById;
  }

  deleteTankerDispatchUrl(): string {
    return apiUrl + TankerDispatch.deleteTankerDispatch;
  }

  updateTankerDispatchUrl(): string {
    return apiUrl + TankerDispatch.updateTankerDispatch;
  }
}

@Injectable({
  providedIn: "root",
})
export class sampleIntimationSetter {
  loadDropDownsUrl(): string {
    return apiUrl + sampleIntimation.loadDropDowns;
  }
  loadProductListUrl(): string {
    return apiUrl + sampleIntimation.loadProductList;
  }
  saveSampleUrl(): string {
    return apiUrl + sampleIntimation.saveSample;
  }
  loadGridUrl(): string {
    return apiUrl + sampleIntimation.loadGrid;
  }
  getByIdUrl(): string {
    return apiUrl + sampleIntimation.getById;
  }
  updateSampleUrl(): string {
    return apiUrl + sampleIntimation.updateSample;
  }
  deleteSampleUrl(): string {
    return apiUrl + sampleIntimation.deleteSample;
  }
  loadLabListUrl(): string {
    return apiUrl + sampleIntimation.loadLabList;
  }
}

@Injectable({
  providedIn: "root",
})
export class TankerDispatchTestingSetter {
  loadTdTestingGridUrl(): string {
    return apiUrl + TankerDispatchTesting.loadTdTestingGrid;
  }
  acknowledgeTdUrl(): string {
    return apiUrl + TankerDispatchTesting.acknowledgeTd;
  }
  getTestingResultsUrl(): string {
    return apiUrl + TankerDispatchTesting.getTestingResults;
  }
  getTestingParametersUrl(): string {
    return apiUrl + TankerDispatchTesting.getTestingParameters;
  }
  getReceiveTestingResultsUrl(): string {
    return apiUrl + TankerDispatchTesting.getReceiveTestingResults;
  }
  modifyTdTestingUrl(): string {
    return apiUrl + TankerDispatchTesting.modifyTdTesting;
  }
  addTdTestingUrl(): string {
    return apiUrl + TankerDispatchTesting.addTdTesting;
  }
}

@Injectable({
  providedIn: "root",
})
export class productTestingSetter {
  loadLabListUrl(): string {
    return apiUrl + productTesting.loadLabList;
  }
  loadGridUrl(): string {
    return apiUrl + productTesting.loadGrid;
  }
  AcknowledgementUrl(): string {
    return apiUrl + productTesting.Acknowledgement;
  }
}

@Injectable({
  providedIn: "root",
})
export class labResultSetter {
  getParametersUrl(): string {
    return apiUrl + labResult.getParameters;
  }

  getResultsUrl(): string {
    return apiUrl + labResult.getResult;
  }

  addParamResultUrl(): string {
    return apiUrl + labResult.addParamResult;
  }

  updateParamResultUrl(): string {
    return apiUrl + labResult.updateParamResult;
  }
}

@Injectable({
  providedIn: "root",
})
// Tanker Movement
export class TankerReceiveSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + TankerReceive.loadMasterDropdowns;
  }
  loadGeneralDropdownsUrl(): string {
    return apiUrl + TankerReceive.loadGeneralDropdowns;
  }
  loadRouteDropdownUrl(): string {
    return apiUrl + TankerReceive.loadRouteDropdown;
  }
  loadReceiveDropdownsUrl(): string {
    return apiUrl + TankerReceive.loadReceiveDropdowns;
  }
  loadUnitListUrl(): string {
    return apiUrl + TankerReceive.loadItemUnitMappingDropdown;
  }
  loadTankerReceiveGridUrl(): string {
    return apiUrl + TankerReceive.loadTankerReceiveGrid;
  }
  addTankerReceiveUrl(): string {
    return apiUrl + TankerReceive.addTankerReceive;
  }
  getTankerReceiveByIdUrl(): string {
    return apiUrl + TankerReceive.getTankerReceiveById;
  }
  getTankerReceiveByIdWithDropdownsUrl(): string {
    return apiUrl + TankerReceive.getTankerReceiveByIdWithDropdowns;
  }
  deleteTankerReceiveUrl(): string {
    return apiUrl + TankerReceive.deleteTankerReceive;
  }
  updateTankerReceiveUrl(): string {
    return apiUrl + TankerReceive.updateTankerReceive;
  }
  unloadReceivedTankerUrl(): string {
    return apiUrl + TankerReceive.unloadReceivedTanker;
  }
  loadCleaningStatusUrl(): string {
    return apiUrl + TankerReceive.loadCleaningStatus;
  }
  saveCleaningStatusUrl(): string {
    return apiUrl + TankerReceive.saveCleaningStatus;
  }
}

@Injectable({
  providedIn: "root",
})
// Tanker Movement
export class TankerReceiveTestingSetter {
  loadTankerReceiveTestingGridUrl(): string {
    return apiUrl + TankerReceiveTesting.loadTankerReceiveTestingGrid;
  }

  acknowledgeReceivedSampleUrl(): string {
    return apiUrl + TankerReceiveTesting.acknowledgeReceivedSample;
  }

  getLabParamsUrl(): string {
    return apiUrl + TankerReceiveTesting.getLabParams;
  }

  generateTrTestingResultsUrl(): string {
    return apiUrl + TankerReceiveTesting.generateTrTestingResults;
  }

  getTrTestingResultsUrl(): string {
    return apiUrl + TankerReceiveTesting.getTrTestingResults;
  }

  generateTdTestingResultsUrl(): string {
    return apiUrl + TankerReceiveTesting.generateTdTestingResults;
  }

  getTdTestingResultsUrl(): string {
    return apiUrl + TankerReceiveTesting.getTdTestingResults;
  }
}
@Injectable({
  providedIn: "root",
})
export class itemMasterGroupSetter {
  loadCompanyDropdownUrl(): string {
    return apiUrl + itemMasterGroup.loadCompanyDropdown;
  }

  LoadItemMasterGroupUrl(): string {
    return apiUrl + itemMasterGroup.loadItemMasterGroup;
  }
  saveItemMasterGroupsUrl(): string {
    return apiUrl + itemMasterGroup.saveItemMasterGroups;
  }
}

@Injectable({
  providedIn: "root",
})
export class dashBoardUrls {
  LoadDashboardDataUrl(): string {
    return apiUrl + dashboard.LoadDashboardData;
  }
}

@Injectable({
  providedIn: "root",
})
export class plantLossGainReportSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + plantLossGainReport.loadMasterDropdowns;
  }

  generateReportUrl(): string {
    return apiUrl + plantLossGainReport.generateReport;
  }
}

@Injectable({
  providedIn: "root",
})
export class sectionLossGainReportSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + sectionLossGainReport.loadMasterDropdowns;
  }

  generateReportUrl(): string {
    return apiUrl + sectionLossGainReport.generateReport;
  }
}

@Injectable({
  providedIn: "root",
})
export class fgProductionReportSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + fgProductionReport.loadMasterDropdowns;
  }
  loadItemDropdownsUrl(): string {
    return apiUrl + fgProductionReport.loadItemDropdowns;
  }

  generateReportUrl(): string {
    return apiUrl + fgProductionReport.generateReport;
  }
}
@Injectable({
  providedIn: "root",
})
export class sfgStockReportSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + sfgStockReport.loadMasterDropdowns;
  }
  loadItemDropdownsUrl(): string {
    return apiUrl + sfgStockReport.loadItemDropdowns;
  }

  generateReportUrl(): string {
    return apiUrl + sfgStockReport.generateReport;
  }
}

@Injectable({
  providedIn: "root",
})
export class TankerMovementReportSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + TankerMovementReport.loadMasterDropdowns;
  }
  generateReportUrl(): string {
    return apiUrl + TankerMovementReport.generateReport;
  }
}
@Injectable({
  providedIn: "root",
})
export class TankerTestingReportSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + TankerTestingReport.loadMasterDropdowns;
  }
  generateReportUrl(): string {
    return apiUrl + TankerTestingReport.generateReport;
  }
}

@Injectable({
  providedIn: "root",
})
export class UnitPackingReportSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + UnitPackingReport.loadMasterDropdowns;
  }
  loadItemDropdownsUrl(): string {
    return apiUrl + UnitPackingReport.loadItemDropdowns;
  }

  generateReportUrl(): string {
    return apiUrl + UnitPackingReport.generateReport;
  }
}
@Injectable({
  providedIn: "root",
})
export class fgProductionSummaryReportSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + fgProductionSummaryReport.loadMasterDropdowns;
  }
  generateReportUrl(): string {
    return apiUrl + fgProductionSummaryReport.generateReport;
  }
}
@Injectable({
  providedIn: "root",
})
export class RmPmStockReportSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + RmPmStockReport.loadMasterDropdowns;
  }
  loadItemDropdownsUrl(): string {
    return apiUrl + RmPmStockReport.loadItemDropdowns;
  }

  generateReportUrl(): string {
    return apiUrl + RmPmStockReport.generateReport;
  }
}

@Injectable({
  providedIn: "root",
})
export class tankerBillingReportSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + tankerBillingReport.loadMasterDropdowns;
  }
  generateReportUrl(): string {
    return apiUrl + tankerBillingReport.generateReport;
  }
}
@Injectable({
  providedIn: "root",
})
export class MilkSaleBillReportSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + MilkSaleBillReport.loadMasterDropdowns;
  }
  loadContranctorDropdownUrl(): string {
    return apiUrl + MilkSaleBillReport.loadContranctorDropdown;
  }

  generateReportUrl(): string {
    return apiUrl + MilkSaleBillReport.generateReport;
  }
}
@Injectable({
  providedIn: "root",
})
export class sfgStockSummaryReportSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + sfgStockSummaryReport.loadMasterDropdowns;
  }

  generateReportUrl(): string {
    return apiUrl + sfgStockSummaryReport.generateReport;
  }
}
@Injectable({
  providedIn: "root",
})
export class sfgProductionReportSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + sfgProductionReport.loadMasterDropdowns;
  }
  loadItemDropdownsUrl(): string {
    return apiUrl + sfgProductionReport.loadItemDropdowns;
  }

  generateReportUrl(): string {
    return apiUrl + sfgProductionReport.generateReport;
  }
}
@Injectable({
  providedIn: "root",
})
export class closingStockReportSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + closingStockReport.loadMasterDropdowns;
  }
  generateReportUrl(): string {
    return apiUrl + closingStockReport.generateReport;
  }
}
@Injectable({
  providedIn: "root",
})
export class MilkProcReportSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + MilkProcReport.loadMasterDropdowns;
  }

  generateReportUrl(): string {
    return apiUrl + MilkProcReport.generateReport;
  }
}
@Injectable({
  providedIn: "root",
})
export class TankerMovementSummaryReportSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + TankerMovementSummaryReport.loadMasterDropdowns;
  }
  generateReportUrl(): string {
    return apiUrl + TankerMovementSummaryReport.generateReport;
  }
}
@Injectable({
  providedIn: "root",
})
export class labAnalysisReportSetter {
  loadMasterDropdownsUrl(): string {
    return apiUrl + labAnalysis.loadMasterDropdowns;
  }
  generateReportUrl(): string {
    return apiUrl + labAnalysis.generateReport;
  }
}

@Injectable({
  providedIn: "root",
})
export class productRejection {
  loadDropdownsUrl(): string {
    return apiUrl + prodRejection.LoadDropDowns;
  }
  loadItemListUrl(): string {
    return apiUrl + prodRejection.loadItemList;
  }
  loadUnitListUrl(): string {
    return apiUrl + prodRejection.loadUnitList;
  }
  loadGridUrl(): string {
    return apiUrl + prodRejection.loadGrid;
  }
  addRejectionUrl(): string {
    return apiUrl + prodRejection.addRejection;
  }
  getByIdUrl(): string {
    return apiUrl + prodRejection.getById;
  }
  updateRejectionUrl(): string {
    return apiUrl + prodRejection.updateRejection;
  }
  deleteRejectionUrl(): string {
    return apiUrl + prodRejection.deleteRejection;
  }
  calculateKgFatKgSnfUrl(): string {
    return apiUrl + prodRejection.calculateKgFatKgSnf;
  }
}

@Injectable({
  providedIn: "root",
})
export class CompanyRightsGetter {
  loadGridUrl(): string {
    return apiUrl + companyRights.loadGrid;
  }

  loadRootLevelMenuUrl(): string {
    return apiUrl + companyRights.loadRootLevelMenu;
  }
  loadCompanyRightsUrl(): string {
    return apiUrl + companyRights.loadCompanyRights;
  }
  assignCompanyRightsUrl(): string {
    return apiUrl + companyRights.assignCompanyRights;
  }
}

@Injectable({
  providedIn: "root",
})
export class companySetting {
  loadDropdownsUrl(): string {
    return apiUrl + companySettings.LoadDropDowns;
  }
  getSettingsByIdUrl(): string {
    return apiUrl + companySettings.getSettingsById;
  }
  onSaveCompanySettingsUrl(): string {
    return apiUrl + companySettings.onSaveCompanySettings;
  }
  loadShiftsUrl(): string {
    return apiUrl + companySettings.loadShifts;
  }
  onAddShiftUrl(): string {
    return apiUrl + companySettings.onAddShift;
  }
  deleteShiftUrl(): string {
    return apiUrl + companySettings.deleteShift;
  }
}
